import { render, staticRenderFns } from "./TooltipSituacao.vue?vue&type=template&id=143528b1&scoped=true&"
import script from "./TooltipSituacao.vue?vue&type=script&lang=js&"
export * from "./TooltipSituacao.vue?vue&type=script&lang=js&"
import style0 from "./TooltipSituacao.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TooltipSituacao.vue?vue&type=style&index=1&id=143528b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143528b1",
  null
  
)

export default component.exports